import { toast } from '../../common_components/Toast/ToastUtils';
import XLSX from "xlsx-js-style";
import moment from "moment";
import { formatStat } from "../../helper/statsFormatter";
// ═══════════════════════════════════════════════════════════
// ✅ STYLE DEFINITIONS (Simple Gray Theme)
// ═══════════════════════════════════════════════════════════
const titleStyle = {
    font: { bold: true, sz: 20, color: { rgb: "181D27" } },
    alignment: { horizontal: "center", vertical: "center" },
    border: { bottom: { style: "thin", color: { rgb: "E5E7EB" } } },
};
const clientNameStyle = {
    font: { bold: true, sz: 14, color: { rgb: "374151" } },
    alignment: { horizontal: "center", vertical: "center" },
};
const dateRangeStyle = {
    font: { bold: false, sz: 12, color: { rgb: "6B7280" } },
    alignment: { horizontal: "center", vertical: "center" },
    border: { bottom: { style: "medium", color: { rgb: "D1D5DB" } } },
};
const networkHeaderStyle = {
    font: { bold: true, sz: 12, color: { rgb: "181D27" } },
    fill: { fgColor: { rgb: "E5E7EB" } },
    alignment: { horizontal: "left", vertical: "center" },
    border: {
        top: { style: "thin", color: { rgb: "D1D5DB" } },
        bottom: { style: "thin", color: { rgb: "D1D5DB" } },
        left: { style: "thin", color: { rgb: "D1D5DB" } },
        right: { style: "thin", color: { rgb: "D1D5DB" } },
    },
};
const columnHeaderStyle = {
    font: { bold: true, sz: 11, color: { rgb: "374151" } },
    fill: { fgColor: { rgb: "F3F4F6" } },
    alignment: { horizontal: "center", vertical: "center" },
    border: {
        top: { style: "thin", color: { rgb: "D1D5DB" } },
        bottom: { style: "thin", color: { rgb: "D1D5DB" } },
        left: { style: "thin", color: { rgb: "D1D5DB" } },
        right: { style: "thin", color: { rgb: "D1D5DB" } },
    },
};
const currentRowStyle = {
    font: { bold: false, sz: 11, color: { rgb: "181D27" } },
    fill: { fgColor: { rgb: "FFFFFF" } },
    alignment: { horizontal: "left", vertical: "center" }, // ✅ was right
    border: {
        top: { style: "thin", color: { rgb: "E5E7EB" } },
        bottom: { style: "thin", color: { rgb: "E5E7EB" } },
        left: { style: "thin", color: { rgb: "E5E7EB" } },
        right: { style: "thin", color: { rgb: "E5E7EB" } },
    },
};
const comparedRowStyle = {
    font: { bold: false, sz: 10, color: { rgb: "6B7280" } },
    fill: { fgColor: { rgb: "F9FAFB" } },
    alignment: { horizontal: "left", vertical: "center" }, // ✅ was right
    border: {
        top: { style: "thin", color: { rgb: "E5E7EB" } },
        bottom: { style: "thin", color: { rgb: "E5E7EB" } },
        left: { style: "thin", color: { rgb: "E5E7EB" } },
        right: { style: "thin", color: { rgb: "E5E7EB" } },
    },
};
const summaryRowStyle = {
    font: { bold: true, sz: 11, color: { rgb: "181D27" } },
    fill: { fgColor: { rgb: "F3F4F6" } },
    alignment: { horizontal: "left", vertical: "center" }, // ✅ was right
    border: {
        top: { style: "medium", color: { rgb: "D1D5DB" } },
        bottom: { style: "medium", color: { rgb: "D1D5DB" } },
        left: { style: "thin", color: { rgb: "D1D5DB" } },
        right: { style: "thin", color: { rgb: "D1D5DB" } },
    },
};
const summaryComparedStyle = {
    font: { bold: true, sz: 10, color: { rgb: "6B7280" } },
    fill: { fgColor: { rgb: "F9FAFB" } },
    alignment: { horizontal: "left", vertical: "center" }, // ✅ was right
    border: {
        top: { style: "thin", color: { rgb: "D1D5DB" } },
        bottom: { style: "medium", color: { rgb: "D1D5DB" } },
        left: { style: "thin", color: { rgb: "D1D5DB" } },
        right: { style: "thin", color: { rgb: "D1D5DB" } },
    },
};
const dateColumnStyle = {
    font: { bold: true, sz: 11, color: { rgb: "181D27" } },
    fill: { fgColor: { rgb: "FFFFFF" } },
    alignment: { horizontal: "left", vertical: "center" },
    border: {
        top: { style: "thin", color: { rgb: "E5E7EB" } },
        bottom: { style: "thin", color: { rgb: "E5E7EB" } },
        left: { style: "thin", color: { rgb: "E5E7EB" } },
        right: { style: "medium", color: { rgb: "D1D5DB" } },
    },
};
const comparedDateStyle = {
    font: { bold: false, sz: 10, color: { rgb: "6B7280" } },
    fill: { fgColor: { rgb: "F9FAFB" } },
    alignment: { horizontal: "left", vertical: "center" },
    border: {
        top: { style: "thin", color: { rgb: "E5E7EB" } },
        bottom: { style: "thin", color: { rgb: "E5E7EB" } },
        left: { style: "thin", color: { rgb: "E5E7EB" } },
        right: { style: "medium", color: { rgb: "D1D5DB" } },
    },
};
const emptyStyle = { fill: { fgColor: { rgb: "FFFFFF" } } };
// ═══════════════════════════════════════════════════════════
// ✅ HELPER FUNCTIONS
// ═══════════════════════════════════════════════════════════
const formatMetricLabel = (key) => {
    const dictionary = {
        gross_sales: "GROSS SALES",
        meta_cost: "META COST",
        google_cost: "GOOGLE COST",
        total_cost: "TOTAL COST",
        outboundclicks: "OUTBOUND CLICKS",
        avg_engagement_time_per_session: "AVG ENG TIME",
    };
    if (dictionary[key.toLowerCase()])
        return dictionary[key.toLowerCase()];
    const removablePrefixes = ["ga", "shopify", "meta", "adword", "bing", "criteo", "klaviyo"];
    let pureKey = key;
    const firstPart = key.split("_")[0];
    if (removablePrefixes.includes(firstPart))
        pureKey = key.replace(`${firstPart}_`, "");
    return pureKey
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .toUpperCase();
};
const formatValue = (value, key) => {
    if (value === undefined || value === null)
        return "-";
    try {
        if (typeof formatStat === "function")
            return String(formatStat(value, key));
    }
    catch (e) { }
    if (typeof value === "number") {
        if (key.includes("revenue") ||
            key.includes("cost") ||
            key.includes("sales") ||
            key.includes("spend") ||
            key.includes("aov")) {
            return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        }
        if (key.includes("rate") || key.includes("roas") || key.includes("ctr") || key.includes("cvr")) {
            return `${value.toFixed(2)}%`;
        }
        if (key.includes("order") || key.includes("session") || key.includes("click") || key.includes("impression")) {
            return Math.round(value).toLocaleString();
        }
        return value.toFixed(2);
    }
    return String(value);
};
const getNetworkKeyFromTitle = (title) => {
    const t = title.toLowerCase();
    if (t.includes("shopify"))
        return "shopify";
    if (t.includes("analytics") && !t.includes("acquisition"))
        return "ga";
    if (t.includes("acquisition"))
        return "ga_acquisition";
    if (t.includes("meta"))
        return "meta";
    if (t.includes("adword") || t.includes("google ads"))
        return "adword";
    if (t.includes("bing"))
        return "bing";
    if (t.includes("criteo"))
        return "criteo";
    if (t.includes("email"))
        return "klaviyo_email";
    if (t.includes("sms"))
        return "klaviyo_sms";
    if (t.includes("flow"))
        return "klaviyo_flow";
    return title.toLowerCase().replace(/\s+/g, "_");
};
const getVisibleMetrics = (allMetrics, preferences, networkKey) => {
    if (!preferences?.[networkKey] || preferences[networkKey].length === 0)
        return allMetrics;
    const networkPrefs = preferences[networkKey];
    const visibilityMap = new Map();
    const orderMap = new Map();
    networkPrefs.forEach((item, index) => {
        const metricKey = Object.keys(item)[0];
        const config = item[metricKey];
        visibilityMap.set(metricKey, config?.visibility !== false);
        orderMap.set(metricKey, config?.order ?? index + 1);
    });
    const visibleMetrics = allMetrics.filter((metric) => {
        const isVisible = visibilityMap.get(metric);
        return isVisible === undefined ? true : isVisible;
    });
    visibleMetrics.sort((a, b) => (orderMap.get(a) ?? 999) - (orderMap.get(b) ?? 999));
    return visibleMetrics;
};
const changeCellStyle = (baseStyle, change) => ({
    ...baseStyle,
    alignment: { horizontal: "left", vertical: "center" }, // ✅ was center
    font: {
        ...baseStyle.font,
        color: { rgb: change >= 0 ? "16A34A" : "DC2626" }, // green/red
    },
});
const formatChangeOnly = (change) => {
    if (change === undefined || isNaN(change))
        return "-";
    return `${Math.abs(change).toFixed(0)}%`;
};
// ═══════════════════════════════════════════════════════════
// ✅ MAIN EXPORT FUNCTION (UPDATED FORMAT)
// ═══════════════════════════════════════════════════════════
export const exportDivergenceExcel = (reportData, options, fileName) => {
    if (!reportData || !Array.isArray(reportData)) {
        console.warn("No report data to export");
        toast.info("No data available to export");
        return;
    }
    try {
        const allRows = [];
        const merges = [];
        const preferences = options?.preferences || null;
        const hasShopify = reportData.some((r) => r.status === "fulfilled" && r.value?.network === "shopify");
        const shouldShowGAMain = !hasShopify || options?.showGACompare === true;
        // ═══════════════════════════════════════════════════════════
        // ✅ COLLECT ALL SECTIONS WITH PROPER ORDERING
        // ═══════════════════════════════════════════════════════════
        const shopifySection = [];
        const gaMainSection = [];
        const gaAcquisitionSection = [];
        const otherSections = [];
        reportData
            .filter((r) => r.status === "fulfilled")
            .forEach((r) => {
            const network = r.value.network;
            const data = r.value.data;
            if (!data)
                return;
            if (network === "shopify") {
                if (data.current?.data?.length || data.compared?.data?.length) {
                    shopifySection.push({ title: "SHOPIFY", block: data });
                }
            }
            else if (network === "ga") {
                // GA MAIN only when shouldShowGAMain
                if (shouldShowGAMain) {
                    if (data.main && (data.main.current?.data?.length || data.main.compared?.data?.length)) {
                        gaMainSection.push({ title: "Google Analytics", block: data.main });
                    }
                }
                // ✅ IMPORTANT: GA Acquisition export ALWAYS if present (even when Shopify exists)
                if (data.acquisition && (data.acquisition.current?.data?.length || data.acquisition.compared?.data?.length)) {
                    gaAcquisitionSection.push({ title: "GA Acquisition", block: data.acquisition, isAcquisition: true });
                }
            }
            else if (network === "klaviyo") {
                if (data.email && (data.email.current?.data?.length || data.email.compared?.data?.length)) {
                    otherSections.push({ title: "Klaviyo - Email", block: data.email });
                }
                if (data.sms && (data.sms.current?.data?.length || data.sms.compared?.data?.length)) {
                    otherSections.push({ title: "Klaviyo - SMS", block: data.sms });
                }
                if (data.flow && (data.flow.current?.data?.length || data.flow.compared?.data?.length)) {
                    otherSections.push({ title: "Klaviyo - Flow", block: data.flow });
                }
            }
            else {
                if (data.current?.data?.length || data.compared?.data?.length) {
                    otherSections.push({ title: network.toUpperCase(), block: data });
                }
            }
        });
        // ORDER: Shopify → GA Main → Other Networks → GA Acquisition
        const sections = [...shopifySection, ...gaMainSection, ...otherSections, ...gaAcquisitionSection];
        // ═══════════════════════════════════════════════════════════
        // ✅ Calculate maxColumns using: 1 + metrics*2 (VALUE + %CHANGE)
        // ═══════════════════════════════════════════════════════════
        let maxColumns = 6;
        sections.forEach((section) => {
            const allMetrics = section.block.metrics || [];
            const networkKey = getNetworkKeyFromTitle(section.title);
            const visibleMetrics = getVisibleMetrics(allMetrics, preferences, networkKey);
            // MONTH/CHANNEL + (metric VALUE + % CHANGE) per metric
            maxColumns = Math.max(maxColumns, 1 + visibleMetrics.length * 2);
        });
        // ═══════════════════════════════════════════════════════════
        // 0️⃣ TOP HEADER SECTION
        // ═══════════════════════════════════════════════════════════
        // Row 0: Title
        const titleRow = [];
        for (let i = 0; i < maxColumns; i++) {
            titleRow.push({ v: i === 0 ? "Divergence Report" : "", t: "s", s: titleStyle });
        }
        allRows.push(titleRow);
        merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: maxColumns - 1 } });
        // Row 1: Client Name
        const clientName = options?.clientName || "";
        const clientRow = [];
        for (let i = 0; i < maxColumns; i++)
            clientRow.push({ v: i === 0 ? clientName : "", t: "s", s: clientNameStyle });
        allRows.push(clientRow);
        merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: maxColumns - 1 } });
        // Row 2: Date Range
        let dateRangeText = "";
        if (options?.startDate && options?.endDate) {
            const startFormatted = moment(options.startDate).format("MM/DD/YYYY");
            const endFormatted = moment(options.endDate).format("MM/DD/YYYY");
            dateRangeText = `${startFormatted} - ${endFormatted}`;
            if (options?.hasComparison && options?.compareStartDate && options?.compareEndDate) {
                const compareStartFormatted = moment(options.compareStartDate).format("MM/DD/YYYY");
                const compareEndFormatted = moment(options.compareEndDate).format("MM/DD/YYYY");
                dateRangeText += `  vs.  ${compareStartFormatted} - ${compareEndFormatted}`;
            }
        }
        const dateRow = [];
        for (let i = 0; i < maxColumns; i++)
            dateRow.push({ v: i === 0 ? dateRangeText : "", t: "s", s: dateRangeStyle });
        allRows.push(dateRow);
        merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: maxColumns - 1 } });
        // Row 3: Spacer
        const spacerRow = [];
        for (let i = 0; i < maxColumns; i++)
            spacerRow.push({ v: "", t: "s", s: emptyStyle });
        allRows.push(spacerRow);
        // ═══════════════════════════════════════════════════════════
        // ✅ PROCESS SECTIONS
        // ═══════════════════════════════════════════════════════════
        let isFirstSection = true;
        sections.forEach((section) => {
            const { title, block, isAcquisition } = section;
            let allMetrics = block.metrics || [];
            const isShopify = title.toUpperCase() === "SHOPIFY";
            const isGa = title.toUpperCase() === "GOOGLE ANALYTICS";
            if (isShopify || isGa) {
                const hasAdword = reportData.some((r) => r.status === 'fulfilled' && (r.value?.network === 'adword' || r.value?.network === 'google ads' || r.value?.network === 'googleads'));
                const hasMeta = reportData.some((r) => r.status === 'fulfilled' && (r.value?.network === 'meta' || r.value?.network === 'facebook'));
                if (!hasAdword)
                    allMetrics = allMetrics.filter((m) => m !== 'google_cost');
                if (!hasMeta)
                    allMetrics = allMetrics.filter((m) => m !== 'meta_cost');
                if (!hasAdword || !hasMeta)
                    allMetrics = allMetrics.filter((m) => m !== 'total_cost');
            }
            const currentData = block.current?.data || [];
            const comparedData = block.compared?.data || [];
            const hasComparison = comparedData.length > 0;
            const networkKey = getNetworkKeyFromTitle(title);
            const metrics = getVisibleMetrics(allMetrics, preferences, networkKey);
            if (metrics.length === 0)
                return;
            // section spacer
            if (!isFirstSection) {
                const emptyRow = [];
                for (let i = 0; i < maxColumns; i++)
                    emptyRow.push({ v: "", t: "s", s: emptyStyle });
                allRows.push(emptyRow);
            }
            isFirstSection = false;
            // 1️⃣ NETWORK HEADER
            const networkRowIndex = allRows.length;
            const networkRow = [];
            for (let i = 0; i < maxColumns; i++)
                networkRow.push({ v: i === 0 ? title : "", t: "s", s: networkHeaderStyle });
            allRows.push(networkRow);
            merges.push({ s: { r: networkRowIndex, c: 0 }, e: { r: networkRowIndex, c: maxColumns - 1 } });
            // 2️⃣ COLUMN HEADERS  (MONTH/CHANNEL + VALUE + %CHANGE per metric)
            const headerRow = [
                {
                    v: isAcquisition ? "CHANNEL" : "MONTH",
                    t: "s",
                    s: { ...columnHeaderStyle, alignment: { horizontal: "left", vertical: "center" } },
                },
            ];
            metrics.forEach((metric) => {
                headerRow.push({ v: formatMetricLabel(metric), t: "s", s: columnHeaderStyle });
                headerRow.push({ v: "% CHANGE", t: "s", s: columnHeaderStyle });
            });
            for (let i = headerRow.length; i < maxColumns; i++)
                headerRow.push({ v: "", t: "s", s: columnHeaderStyle });
            allRows.push(headerRow);
            // 3️⃣ DATA
            const currentMap = new Map();
            const comparedMap = new Map();
            currentData.forEach((row) => {
                const key = isAcquisition ? row.channel : moment(row.date).format("YYYY-MM");
                currentMap.set(key, row);
            });
            comparedData.forEach((row) => {
                const key = isAcquisition ? row.channel : moment(row.date).format("YYYY-MM");
                comparedMap.set(key, row);
            });
            const currentLabels = block.current?.labels?.length ? block.current.labels : Array.from(currentMap.keys()).sort();
            const comparedLabels = block.compared?.labels?.length ? block.compared.labels : Array.from(comparedMap.keys()).sort();
            if (isAcquisition) {
                const allChannels = Array.from(new Set([...currentMap.keys(), ...comparedMap.keys()])).sort();
                allChannels.forEach((channel) => {
                    const currentRow = currentMap.get(channel);
                    const comparedRow = comparedMap.get(channel);
                    // CURRENT row
                    const currentDataRow = [{ v: channel, t: "s", s: dateColumnStyle }];
                    metrics.forEach((metric) => {
                        const currentVal = currentRow?.[metric];
                        const comparedVal = comparedRow?.[metric];
                        currentDataRow.push({
                            v: currentVal === undefined || currentVal === null ? "-" : formatValue(currentVal, metric),
                            t: "s",
                            s: currentRowStyle,
                        });
                        let change = undefined;
                        if (currentVal !== undefined && comparedVal !== undefined && comparedVal !== 0) {
                            change = ((currentVal - comparedVal) / Math.abs(comparedVal)) * 100;
                        }
                        currentDataRow.push({
                            v: hasComparison ? formatChangeOnly(change) : "",
                            t: "s",
                            s: hasComparison && change !== undefined ? changeCellStyle(currentRowStyle, change) : currentRowStyle,
                        });
                    });
                    for (let i = currentDataRow.length; i < maxColumns; i++)
                        currentDataRow.push({ v: "", t: "s", s: currentRowStyle });
                    allRows.push(currentDataRow);
                    // COMPARED row
                    if (hasComparison && comparedRow) {
                        const comparedDataRow = [{ v: "", t: "s", s: comparedDateStyle }];
                        metrics.forEach((metric) => {
                            const comparedVal = comparedRow?.[metric];
                            comparedDataRow.push({
                                v: comparedVal === undefined || comparedVal === null ? "-" : formatValue(comparedVal, metric),
                                t: "s",
                                s: comparedRowStyle,
                            });
                            // blank change column
                            comparedDataRow.push({ v: "", t: "s", s: comparedRowStyle });
                        });
                        for (let i = comparedDataRow.length; i < maxColumns; i++)
                            comparedDataRow.push({ v: "", t: "s", s: comparedRowStyle });
                        allRows.push(comparedDataRow);
                    }
                });
            }
            else {
                const rowCount = Math.max(currentLabels.length, comparedLabels.length);
                for (let i = 0; i < rowCount; i++) {
                    const currentKey = currentLabels[i];
                    const comparedKey = comparedLabels[i];
                    const currentRow = currentKey ? currentMap.get(currentKey) : undefined;
                    const comparedRow = comparedKey ? comparedMap.get(comparedKey) : undefined;
                    const displayDate = currentKey ? moment(currentKey, "YYYY-MM").format("MMM YY") : "-";
                    const comparedDisplayDate = comparedKey ? moment(comparedKey, "YYYY-MM").format("MMM YY") : "";
                    // CURRENT row
                    const currentDataRow = [{ v: displayDate, t: "s", s: dateColumnStyle }];
                    metrics.forEach((metric) => {
                        const currentVal = currentRow?.[metric];
                        const comparedVal = comparedRow?.[metric];
                        currentDataRow.push({
                            v: currentVal === undefined || currentVal === null ? "-" : formatValue(currentVal, metric),
                            t: "s",
                            s: currentRowStyle,
                        });
                        let change = undefined;
                        if (currentVal !== undefined && comparedVal !== undefined && comparedVal !== 0) {
                            change = ((currentVal - comparedVal) / Math.abs(comparedVal)) * 100;
                        }
                        currentDataRow.push({
                            v: hasComparison ? formatChangeOnly(change) : "",
                            t: "s",
                            s: hasComparison && change !== undefined ? changeCellStyle(currentRowStyle, change) : currentRowStyle,
                        });
                    });
                    for (let i2 = currentDataRow.length; i2 < maxColumns; i2++)
                        currentDataRow.push({ v: "", t: "s", s: currentRowStyle });
                    allRows.push(currentDataRow);
                    // COMPARED row
                    if (hasComparison && comparedKey) {
                        const comparedDataRow = [{ v: comparedDisplayDate, t: "s", s: comparedDateStyle }];
                        metrics.forEach((metric) => {
                            const comparedVal = comparedRow?.[metric];
                            comparedDataRow.push({
                                v: comparedVal === undefined || comparedVal === null ? "-" : formatValue(comparedVal, metric),
                                t: "s",
                                s: comparedRowStyle,
                            });
                            comparedDataRow.push({ v: "", t: "s", s: comparedRowStyle });
                        });
                        for (let i2 = comparedDataRow.length; i2 < maxColumns; i2++)
                            comparedDataRow.push({ v: "", t: "s", s: comparedRowStyle });
                        allRows.push(comparedDataRow);
                    }
                }
            }
            // 4️⃣ SUMMARY
            if (block.summary?.current_totals) {
                const summaryCurrentRow = [
                    {
                        v: isAcquisition ? "Total Summary" : "Summary",
                        t: "s",
                        s: { ...summaryRowStyle, alignment: { horizontal: "left", vertical: "center" } },
                    },
                ];
                metrics.forEach((metric) => {
                    const currentTotal = block.summary.current_totals?.[metric];
                    const comparedTotal = block.summary.compared_totals?.[metric];
                    summaryCurrentRow.push({
                        v: currentTotal === undefined || currentTotal === null ? "-" : formatValue(currentTotal, metric),
                        t: "s",
                        s: summaryRowStyle,
                    });
                    let change = undefined;
                    if (currentTotal !== undefined && comparedTotal !== undefined && comparedTotal !== 0) {
                        change = ((currentTotal - comparedTotal) / Math.abs(comparedTotal)) * 100;
                    }
                    summaryCurrentRow.push({
                        v: hasComparison ? formatChangeOnly(change) : "",
                        t: "s",
                        s: hasComparison && change !== undefined ? changeCellStyle(summaryRowStyle, change) : summaryRowStyle,
                    });
                });
                for (let i = summaryCurrentRow.length; i < maxColumns; i++)
                    summaryCurrentRow.push({ v: "", t: "s", s: summaryRowStyle });
                allRows.push(summaryCurrentRow);
                if (hasComparison && block.summary.compared_totals) {
                    const summaryComparedRow = [{ v: "", t: "s", s: summaryComparedStyle }];
                    metrics.forEach((metric) => {
                        const comparedTotal = block.summary.compared_totals?.[metric];
                        summaryComparedRow.push({
                            v: comparedTotal === undefined || comparedTotal === null ? "-" : formatValue(comparedTotal, metric),
                            t: "s",
                            s: summaryComparedStyle,
                        });
                        summaryComparedRow.push({ v: "", t: "s", s: summaryComparedStyle });
                    });
                    for (let i = summaryComparedRow.length; i < maxColumns; i++)
                        summaryComparedRow.push({ v: "", t: "s", s: summaryComparedStyle });
                    allRows.push(summaryComparedRow);
                }
            }
        });
        // ═══════════════════════════════════════════════════════════
        // ✅ CREATE EXCEL FILE
        // ═══════════════════════════════════════════════════════════
        if (allRows.length === 0) {
            toast.info("No data available to export");
            return;
        }
        const worksheet = {};
        allRows.forEach((row, rowIndex) => {
            row.forEach((cell, colIndex) => {
                const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
                worksheet[cellRef] = cell;
            });
        });
        worksheet["!ref"] = XLSX.utils.encode_range({
            s: { r: 0, c: 0 },
            e: { r: allRows.length - 1, c: maxColumns - 1 },
        });
        worksheet["!merges"] = merges;
        // Column widths: Month/Channel wider, metric value wider, %change narrower
        const colWidths = [{ wch: 18 }];
        for (let i = 1; i < maxColumns; i++) {
            // odd index => metric value, even index => % change (because after date col, we push pairs)
            colWidths.push({ wch: i % 2 === 0 ? 11 : 20 });
        }
        worksheet["!cols"] = colWidths;
        // Row heights
        const rowHeights = [];
        allRows.forEach((_, index) => {
            if (index === 0)
                rowHeights.push({ hpt: 35 });
            else if (index === 1)
                rowHeights.push({ hpt: 26 });
            else if (index === 2)
                rowHeights.push({ hpt: 22 });
            else if (index === 3)
                rowHeights.push({ hpt: 15 });
            else
                rowHeights.push({ hpt: 22 });
        });
        worksheet["!rows"] = rowHeights;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Divergence Report");
        const dateStr = moment().format("YYYY-MM-DD_HH-mm");
        const finalFileName = fileName || `Divergence_Report_${dateStr}.xlsx`;
        XLSX.writeFile(workbook, finalFileName);
    }
    catch (error) {
        console.error("Export failed:", error);
        toast.info("Failed to export data. Please try again.");
    }
};
export default exportDivergenceExcel;
